import { render, staticRenderFns } from "./UploadImport.vue?vue&type=template&id=62970fdc&"
import script from "./UploadImport.vue?vue&type=script&lang=js&"
export * from "./UploadImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports